// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13xNz","content":"styles_content__25U23","tableWrap":"styles_tableWrap__37lZi"};